/** Contact details shown across the landing page. */
export const CONTACT_EMAIL = "jkleinveld@auxilium.nl";
export const CONTACT_PHONE_DISPLAY = "015 26 123 16";
export const CONTACT_PHONE_HREF = "tel:+31152612316";
